export default __webpack_public_path__ + "images/orange-game-control.svg";